module.exports = __webpack_public_path__ + "img/公司官网_客户案例-国企.4da2c6c6.png";